import { Helmet } from 'react-helmet-async';
import { MapPin, Phone, Mail, Shield, Users, Heart } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import getCanonicalUrl from '../utils/canonical';

const Caserta = () => {

  return (
    <div className="page-container">
      <Helmet>
        <title>Agenzia Matrimoniale Caserta – Incontri seri | Officine del Cuore</title>
        <meta name="description" content="Agenzia matrimoniale a Caserta per single che desiderano incontri seri e sicuri. Officine del Cuore aiuta i single a trovare un partner compatibile. Contatta adesso." />
        <link rel="canonical" href={getCanonicalUrl('agenzia-matrimoniale-caserta')} />
      </Helmet>

      {/* Hero Section */}
      <section className="page-hero" style={{backgroundImage: 'url(https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/ne64y3iv_fidanzati%20caserta.webp)'}}>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="page-title fade-in">Agenzia Matrimoniale Caserta</h1>
          <p className="page-subtitle fade-in-delay">
            Agenzia per Single Officine del Cuore: solo per Single in cerca dell'anima gemella
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="section-elegant">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="section-title text-center mb-8">
            La Tua Agenzia Matrimoniale a Caserta
          </h2>
          <div className="prose-elegant">
            <p>
              Officine del Cuore è il punto di riferimento per chi cerca una relazione seria e duratura a Caserta e in provincia. Grazie alla vicinanza con la nostra sede di Napoli, garantiamo la stessa qualità, attenzione e professionalità che da oltre 19 anni ci contraddistingue. Conosciamo il territorio casertano, le sue tradizioni e il carattere delle persone che lo abitano: questo ci permette di creare abbinamenti autentici e mirati.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section-elegant bg-warm-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="section-title text-center mb-12">
            Come lavoriamo a Caserta
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="benefit-card">
              <CardContent className="p-6 text-center">
                <div className="benefit-icon-wrapper">
                  <Shield className="benefit-icon" />
                </div>
                <h3 className="benefit-title">Profili Certificati</h3>
                <p className="benefit-description">
                  Tutti gli iscritti sono verificati con la massima diligenza.
                </p>
              </CardContent>
            </Card>

            <Card className="benefit-card">
              <CardContent className="p-6 text-center">
                <div className="benefit-icon-wrapper">
                  <Users className="benefit-icon" />
                </div>
                <h3 className="benefit-title">Incontri Mirati</h3>
                <p className="benefit-description">
                  Compatibilità e affinità studiate a tavolino.
                </p>
              </CardContent>
            </Card>

            <Card className="benefit-card">
              <CardContent className="p-6 text-center">
                <div className="benefit-icon-wrapper">
                  <Heart className="benefit-icon" />
                </div>
                <h3 className="benefit-title">Assistenza personalizzata continua</h3>
                <p className="benefit-description">
                  Un professionista esperto ti ascolta e ti guida costantemente.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Info Boxes Section - 5 Boxes */}
      <section className="section-elegant">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Box 1 */}
            <Card className="info-card">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4" style={{color: 'var(--burgundy)'}}>
                  Perché scegliere un'agenzia matrimoniale per Caserta
                </h3>
                <p className="leading-relaxed mb-3" style={{color: 'var(--burgundy)'}}>
                  Sempre più single preferiscono affidarsi a una agenzia per single a Caserta piuttosto che utilizzare applicazioni o piattaforme casuali.
                </p>
                <p className="leading-relaxed mb-3" style={{color: 'var(--burgundy)'}}>
                  Il nostro servizio permette di:
                </p>
                <ul className="list-disc list-inside space-y-1 mb-3" style={{color: 'var(--burgundy)'}}>
                  <li>conoscere persone realmente interessate a una relazione stabile</li>
                  <li>incontrare single selezionati e compatibili</li>
                  <li>evitare delusioni e conoscenze superficiali</li>
                  <li>ricevere supporto e consulenza durante il percorso</li>
                </ul>
                <p className="leading-relaxed" style={{color: 'var(--burgundy)'}}>
                  Il nostro obiettivo è creare incontri seri a Caserta tra persone che desiderano davvero costruire una relazione importante.
                </p>
              </CardContent>
            </Card>

            {/* Box 2 */}
            <Card className="info-card">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4" style={{color: 'var(--burgundy)'}}>
                  Il nostro metodo anche per Caserta
                </h3>
                <p className="font-semibold leading-relaxed mb-3" style={{color: 'var(--burgundy)'}}>
                  Un servizio discreto e professionale
                </p>
                <p className="leading-relaxed mb-3" style={{color: 'var(--burgundy)'}}>
                  Officine del Cuore offre un servizio riservato e personalizzato per ogni persona.
                </p>
                <p className="leading-relaxed mb-2" style={{color: 'var(--burgundy)'}}>
                  Il percorso prevede:
                </p>
                <ul className="list-disc list-inside space-y-1 mb-3" style={{color: 'var(--burgundy)'}}>
                  <li>un colloquio conoscitivo riservato</li>
                  <li>la valutazione delle affinità e delle aspettative</li>
                  <li>la proposta di incontri compatibili</li>
                  <li>un supporto continuo</li>
                </ul>
                <p className="leading-relaxed" style={{color: 'var(--burgundy)'}}>
                  Questo metodo permette di favorire incontri autentici tra single a Caserta che condividono valori e obiettivi simili.
                </p>
              </CardContent>
            </Card>

            {/* Box 3 */}
            <Card className="info-card">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4" style={{color: 'var(--burgundy)'}}>
                  Agenzia matrimoniale a Caserta per incontri seri
                </h3>
                <p className="leading-relaxed" style={{color: 'var(--burgundy)'}}>
                  Puoi iscriverti a distanza tramite consulto telefonico e videochiamata oppure venendo in sede a Caserta, in entrambi i casi ci sarà la verifica dei documenti di riconoscimento. Officine del Cuore è vicina a te, ovunque tu sia nella provincia di Caserta.
                </p>
              </CardContent>
            </Card>

            {/* Box 4 */}
            <Card className="info-card">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4" style={{color: 'var(--burgundy)'}}>
                  Incontri seri per single a Caserta
                </h3>
                <p className="leading-relaxed" style={{color: 'var(--burgundy)'}}>
                  Terra di storia, cultura e tradizioni profonde, Caserta è una città dove i legami familiari e i valori autentici contano ancora. Officine del Cuore condivide questi stessi principi: crediamo nell'amore costruito sulla fiducia, sul rispetto e sulla conoscenza reciproca. Se cerchi una relazione vera a Caserta, sei nel posto giusto. Contattaci oggi stesso per un primo colloquio gratuito e senza impegno.
                </p>
              </CardContent>
            </Card>

            {/* Box 5 - Full Width */}
            <Card className="info-card md:col-span-2">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-4" style={{color: 'var(--burgundy)'}}>
                  Consulto a distanza oppure in sede
                </h3>
                <p className="leading-relaxed mb-3" style={{color: 'var(--burgundy)'}}>
                  Puoi accedere ai nostri servizi recandoti in sede oppure con un colloquio approfondito al telefono e in videochiamata, comodamente da casa. L'iscrizione a distanza non riduce la qualità del servizio, anzi ti consente un risparmio economico grazie a minori costi organizzativi e a un percorso più semplice e diretto. Gli iscritti sono in ogni caso verificati e certificati con l'invio dei documenti.
                </p>
                <p className="leading-relaxed" style={{color: 'var(--burgundy)'}}>
                  Se vuoi puoi iniziare da dove ti senti più a tuo agio: da casa tua. Non è il posto che fa la differenza. È l'attenzione che ricevi.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Info Caserta */}
      <section className="section-elegant bg-warm-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="section-title text-center mb-12">
            Contattaci
          </h2>
          <Card className="contact-card">
            <CardContent className="p-8">
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <MapPin className="text-gold" size={24} />
                  <div>
                    <p className="font-medium">Caserta</p>
                    <p className="text-sm">Viale Vincenzo Cappiello, 8 – Caserta</p>
                  </div>
                </div>
                <div className="contact-info-item">
                  <Phone className="text-gold" size={24} />
                  <a href="tel:+393520567001" className="hover:text-gold transition-colors">
                    +39 3520567001
                  </a>
                </div>
                <div className="contact-info-item">
                  <Mail className="text-gold" size={24} />
                  <a href="mailto:info@officinedelcuore.it" className="hover:text-gold transition-colors">
                    info@officinedelcuore.it
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section-alt">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="cta-title">
            Richiedi un Colloquio Riservato
          </h2>
          <p className="cta-description">
            Contattaci per un colloquio conoscitivo gratuito. 
            Scopri come possiamo aiutarti a trovare la persona giusta per te a Caserta.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
            <Link to="/contatti">
              <Button size="lg" className="btn-primary btn-large">
                Contattaci Ora
              </Button>
            </Link>
            <a href="tel:+393520567001">
              <Button size="lg" className="btn-primary btn-large">
                Chiama Ora
              </Button>
            </a>
            <a href="https://wa.me/393520567001" target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="btn-primary btn-large">
                WhatsApp
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Caserta;
